export const preferencesSetting = [
  {
    mainHeading: "Ledger",
    details: [
      {
        heading: "Include Dividend",
        value: false,
      },
    ],
  },
];

export const brokerSupport = [
  {
    mainHeading: "Broker Support",
    details: [
      {
        heading: "Aditya Birla",
        key: "adityaBirlaSupport",
        value: false,
      },
      {
        heading: "PMS Support",
        key: "pmsSupport",
        value: false,
      },
      {
        heading: "IIFL Support",
        key: "iiflSupport",
        value: false,
      },
      {
        heading: "Latin Manherlal",
        key: "lmSupport",
        value: false,
      },
    ],
  },
];
